export default "__VITE_ASSET__BCk6u$Mn__"